var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("q-page", { attrs: { padding: "" } }, [
    _c(
      "div",
      { staticClass: "q-display-1 q-mb-md text-secondary" },
      [
        _c("q-icon", { staticClass: "q-mb-sm", attrs: { name: "far fa-box" } }),
        _vm._v(" " + _vm._s(_vm.$t("photo_types")) + "\n    ")
      ],
      1
    ),
    _c("div", { staticClass: "row gutter-sm" }, [
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-12" },
        [
          _c("q-input", {
            attrs: {
              "float-label": _vm.$t("title"),
              error: _vm.$v.title.$error
            },
            on: { input: _vm.$v.title.$touch },
            model: {
              value: _vm.title,
              callback: function($$v) {
                _vm.title = $$v
              },
              expression: "title"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-12" },
        [
          _c("q-input", {
            attrs: {
              type: "number",
              "float-label": _vm.$t("points"),
              error: _vm.$v.points.$error
            },
            on: { input: _vm.$v.points.$touch },
            model: {
              value: _vm.points,
              callback: function($$v) {
                _vm.points = $$v
              },
              expression: "points"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-12" },
        [
          _c("p", { staticClass: "caption" }, [
            _vm._v(_vm._s(_vm.$t("image")))
          ]),
          _c("uploader", {
            attrs: {
              content_type: "images",
              multiple: false,
              cropper: true,
              aspect_ratio: 512 / 512,
              aspect_ratio_string: "512/512"
            },
            on: { fileUploaded: _vm.imageUploaded }
          }),
          _vm.image
            ? _c(
                "p",
                { staticClass: "q-mt-md file-url" },
                [
                  _c("q-icon", {
                    attrs: { name: "fal fa-check", color: "positive" }
                  }),
                  _c("a", { attrs: { href: _vm.image, target: "_blank" } }, [
                    _vm._v(" " + _vm._s(_vm.$truncateLink(_vm.image)))
                  ])
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ]),
    _c("div", { staticClass: "row gutter-sm justify-end q-mt-lg" }, [
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("cancel") },
        [
          _c("q-btn", {
            staticClass: "full-width",
            attrs: {
              color: "tertiary",
              label: _vm.$t("back"),
              icon: "far fa-chevron-left"
            },
            on: {
              click: function($event) {
                return _vm.$router.push({ name: "photo_types" })
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("save") },
        [
          _c("q-btn", {
            staticClass: "full-width",
            attrs: {
              color: "secondary",
              label: _vm.$t("save"),
              icon: "far fa-save"
            },
            on: {
              click: function($event) {
                return _vm.saveData()
              }
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }